import axios from 'axios'
import store from '@/store/store'

export default () => {
  return axios.create({
    baseURL: process.env.VUE_APP_BASE_URL + '/api/',
    headers: {
      Authorization: `Bearer ${store.state.token}`
    }
  })
}